/** Colour-named values stored before themes were named for their role. */
const THEME_BY_LEGACY_VALUE: Record<string, string> = {
  "campaign-shell": "campaign",
  "clear-sky": "calm",
  friendly: "warm",
  holiday: "holiday-bold",
  "holiday-clear-sky": "holiday-calm",
  "new-beginnings": "bold",
  "on-media": "inherit",
  support: "soft",
  white: "page",
};

/**
 * Reads a stored theme, translating a colour-named value to its role name.
 *
 * @maintenance Remove once the `unset-retired-theme-fields` migration has run
 * in every dataset; until then location search result and state office list
 * sections, and lead flow steps, can still store colour-named values.
 */
function resolveLegacyTheme<TTheme extends string>(
  value: TTheme | null | undefined,
): TTheme | undefined {
  if (!value) {
    return undefined;
  }

  return (THEME_BY_LEGACY_VALUE[value] ?? value) as TTheme;
}

export { resolveLegacyTheme };
